import React from "react";
import "./Header.css";
import logoPresval from "../../../img/login/mei_presval_titulo.svg";

const Header = (props) => {
  return (
      <div className={["container-header"].join(" ")}>
        <div className="container-logo">
          <img alt="lightBulb" src={logoPresval} />
        </div>
    </div>
  );
};

export default Header;
